import React from 'react'
import { CarouselItem } from './carousel-item'

export const SupportHero = () => {
  return (
    <CarouselItem>
      <div>
        <h2 className="animate__animated animate__fadeInDown">We support our customer passionately.</h2>
        <p className="animate__animated animate__fadeInUp"> </p>
        <h4 className="animate__animated animate__fadeInUp text-white ">
          Call toll-free 1.855.MILKPRO{' '}
          <a href="tel:8556455776">
            <b>(855.645.5776)</b>
          </a>
        </h4>
        <h4 className="animate__animated animate__fadeInUp text-white ">
          Email us at <a href="mailto:support@totalmilk.com">support@totalmilk.com</a>
        </h4>
      </div>
    </CarouselItem>
  )
}
